import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { cn } from "../../lib/utils";

const Slider = React.forwardRef(({ className, style, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex w-full touch-none select-none items-center",
      className
    )}
    style={style}
    {...props}
  >
    <SliderPrimitive.Track 
      className="relative h-1.5 w-full grow overflow-hidden rounded-full"
      style={{ backgroundColor: style?.["--slider-track-bg"] || "hsl(var(--primary) / 0.2)" }}
    >
      <SliderPrimitive.Range 
        className="absolute h-full"
        style={{ backgroundColor: style?.["--slider-range-bg"] || "hsl(var(--primary))" }}
      />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb 
      className="block h-4 w-4 rounded-full bg-background shadow transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50"
      style={{ borderWidth: "1px", borderStyle: "solid", borderColor: style?.["--slider-thumb-border"] || "hsl(var(--primary) / 0.5)" }}
    />
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
